import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../../config/AuthContext";
import {Table, TableProps, Tag} from "antd";
import {GetJBbddProblemesIdEnviament} from "../../../../dao/bbdd/GetJBbddProblemesIdEnviament";
import {ColumnsType} from "antd/es/table";
import BbddColors from "../../../../styles/BbddColors";
import { FaEye } from "react-icons/fa";
import Editor from "@monaco-editor/react";

const ProblemaIdEnviaments = () => {
    const {isLoggedIn, userId} = useContext(AuthContext);
    const {id_problema, id_activitat} = useParams();
    const [dades, setDades] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_problema, id_activitat]);

    async function checkDades() {
        setLoading(true);
        const dad = await GetJBbddProblemesIdEnviament(id_problema + "", userId, id_activitat);
        setDades(dad || []);
        setLoading(false);
    }

    /** Subfila expandida: muestra el SQL enviado */
    const subRowRender = (record: any) => (
        <div
            style={{
                backgroundColor: "#fafafa",
                padding: "16px",
                borderRadius: "10px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
            }}
        >
            <h5 style={{ marginBottom: 8, color: BbddColors.colors.color5 }}>
                Resposta enviada:
            </h5>
            <Editor
                height="30vh"
                defaultLanguage="sql"
                value={record.actual || "-- Sense resposta --"}
                theme="vs-light"
                options={{ readOnly: true, minimap: { enabled: false } }}
            />
        </div>
    );

    /** Columnas principales */
    const columns: ColumnsType<any> = [
        {
            key: "expand",
            width: 40,
            render: (_, record) =>
                record.actual ? (
                    <FaEye
                        style={{
                            cursor: "pointer",
                            fontSize: 16,
                            color: expandedRowKeys.includes(record.id_usuari)
                                ? BbddColors.colors.color4
                                : "gray",
                        }}
                        onClick={() => {
                            if (expandedRowKeys.includes(record.id_usuari))
                                setExpandedRowKeys([]);
                            else setExpandedRowKeys([record.id_usuari]);
                        }}
                    />
                ) : null,
        },
        {
            key: 'moment',
            dataIndex: 'moment',
            width: 20,
            render: (e) => (
                <Tag color={BbddColors.colors.color2}>{e}</Tag>
            )
        },
        {
            key: 'estat',
            dataIndex: 'estat',
            width: 10,
            render: (e) => (
                <Tag color={e === 2 ? BbddColors.colors.color6 : BbddColors.colors.color1}>
                    {e === 2 ? "CORRECTE" : "INCORRECTE"}
                </Tag>
            )
        },
        {
            key: 'ordre',
            dataIndex: 'ordre',
            width: 10,
            render: (e) => (
                <Tag color={BbddColors.colors.color3}>Test #{e}</Tag>
            )
        },
        {
            key: 'errors',
            dataIndex: 'errors',
            width: 350,
            render: (err) => (
                <Tag color={err ? "red" : "green"}>
                    {err ? err : "Sense errors"}
                </Tag>
            ),
        },
    ];

    const tableProps: TableProps<any> = { loading };

    return (
        <>
            <br/>
            <Table
                size="small"
                bordered
                title={() => "ENVIAMENTS"}
                {...tableProps}
                columns={columns}
                dataSource={dades}
                rowKey="id_usuari"
                expandable={{
                    expandedRowKeys,
                    expandIconColumnIndex: -1,
                    expandedRowRender: subRowRender,
                }}
                pagination={false}
            />
        </>
    );
};

export default ProblemaIdEnviaments;
